// Body of the password-reset request view: the legacy account-page layout --
// the brand heading, the PasswordResetForm rendered as a native React field
// tree, the decorative account image, and the customer-service info block. The
// help text + submit label arrive as props (server-side gettext / builder
// literal); the help text renders inside the form (legacy parity). The
// customer-service block travels as the cs_info_json seam, outside the
// capped-width wrapper.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AuthCustomerServiceBlock } from "../AuthCustomerServiceBlock";

type IProps = Immutable<templates.PasswordResetDocumentTemplate>;

export const PasswordResetBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <>
            <div className="l-capped-width">
                <header>
                    <h1>{props.page_copy?.page_heading}</h1>
                </header>

                <section className="account-page-container">
                    <div>
                        <h2>{props.page_copy?.section_heading}</h2>
                        <div>
                            <form
                                id="password_reset_form"
                                className="js-kuid-form"
                                action={props.action_url}
                                method="post"
                            >
                                <p className={FORM_HELP_TEXT_CLASS_NAME}>
                                    {props.help_text}
                                </p>
                                <CSRFToken />
                                <FormFields
                                    fields={props.fields}
                                    field_labels={props.field_labels}
                                    field_errors={props.field_errors}
                                    non_field_errors={props.non_field_errors}
                                />
                                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                    <input
                                        type="submit"
                                        className="button button--full-width"
                                        value={props.submit_text}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div>
                        {props.page_copy?.account_image ? (
                            <img
                                src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                                alt={props.page_copy.account_image_alt}
                            />
                        ) : null}
                    </div>
                </section>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </>
    );
};
